import { api } from './client';

export type KycStatus = 'NONE' | 'PENDING' | 'APPROVED' | 'REJECTED';

export interface KycSubmissionView {
  id: string;
  submittedAt: string;
  decidedAt: string | null;
  status: KycStatus;
  documentType: string;
  fullName: string | null;
  dateOfBirth: string | null;  // YYYY-MM-DD
  mobileNumber: string | null;
  countryCode: string | null;
  countryOther: string | null;
  rejectionReason: string | null;
  adminNotes: string | null;
  hasTaxId: boolean;
  hasTaxDocument: boolean;
}

export interface KycStatusResponse {
  status: KycStatus;
  approvedAt: string | null;
  canSubmit: boolean;
  submission: KycSubmissionView | null;
}

export interface KycSubmitResponse {
  message: string;
  submissionId: string;
  status: KycStatus;
  submission: KycSubmissionView;
}

export const kycApi = {
  status: () => api<KycStatusResponse>('/api/kyc/status'),
  submit: (form: FormData) =>
    api<KycSubmitResponse>('/api/kyc/submit', {
      method: 'POST',
      body: form,
      isMultipart: true,
    }),
};
